import React from 'react';
import { classNames, layoutClassNames, LayoutClassNameProps } from './classNames';

export type AvatarSize = 'sm' | 'md' | 'lg' | number;

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement>, LayoutClassNameProps {
  size?: AvatarSize;
}

const AVATAR_SIZES: Record<Exclude<AvatarSize, number>, number> = {
  sm: 32,
  md: 36,
  lg: 60,
};

const Avatar: React.FC<AvatarProps> = ({
  size = 'md',
  className,
  style,
  alt,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  ...props
}) => {
  const pixelSize = typeof size === 'number' ? size : AVATAR_SIZES[size];

  return (
    <img
      alt={alt}
      className={classNames(
        'rounded-circle',
        layoutClassNames({
          margin,
          marginTop,
          marginEnd,
          marginBottom,
          marginStart,
          marginX,
          marginY,
          padding,
          paddingTop,
          paddingEnd,
          paddingBottom,
          paddingStart,
          paddingX,
          paddingY,
          textAlign,
        }),
        className,
      )}
      style={{
        width: `${pixelSize}px`,
        height: `${pixelSize}px`,
        objectFit: 'cover',
        ...style,
      }}
      {...props}
    />
  );
};

export default Avatar;
